import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import hamburger from "../images/hamburgerMenu.svg"
import noRingLogo from "../images/DT_logo_no-ring.svg"

function Header() {
  const [menuIsOpen, setMenu] = React.useState(false)
  return(
  /*<!-- component -->
  <!-- Dark Header component -->
   <!-- Fontswesome -->*/

      <header className="flex flex flex-col md:flex-row px-4 py-3 justify-between bg-gradient-to-t md:bg-gradient-to-tl from-gray-800 to-gray-600 font-dokdo text-white">
            <div className="title-font font-medium flex flex-row md:flex-none justify-between">
                <Link to="/">
                    <img 
                        src={noRingLogo}
                        width={175}
                        class={menuIsOpen ? "invisible" : "block"}
                        className="transform hover:scale-105 transition ease-in"
                        alt="logo"
                    />
                </Link>
                <button id="menuBtn" className="block md:hidden focus:outline-none transform hover:scale-105 transition ease-in" type="button" onClick={() => setMenu(!menuIsOpen)}>
                    <img src={hamburger}/>
                </button>
            </div>
            <nav class={menuIsOpen ? "h-screen decoration-clone mt-8 space-y-8 text-5xl text-center" : "hidden md:flex md:ml-auto items-center text-5xl"}>
                <Link to="/" className="block md:mr-7 hover:text-purple-200 cursor-pointer transform hover:scale-105 transition ease-in">Home</Link>
                <Link to="/explore" className="block md:mr-7 hover:text-purple-200 cursor-pointer transform hover:scale-105 transition ease-in">Explore</Link>
                <Link to="/support" className="block md:mr-7 hover:text-purple-200 cursor-pointer transform hover:scale-105 transition ease-in">Support</Link>
            </nav>
      </header>
  )
}

export default Header
